import React from 'react';
import {Icon, Popup} from 'semantic-ui-react';
/* import {Checkbox} from 'semantic-ui-react'; */

export const renderCheckIcon = () => {
  return <Icon name='check circle' color='green' size='large' />;
};

export const renderCrossIcon = () => {
  return <Icon name='cancel' color='red' size='large' />;
};

export const renderReservedCheckIcon = (vehicle) => {
  return <Popup trigger={ vehicle.hasAccessories && vehicle.transferStatus !== 'C' ?
    <Icon name='time circle' color='yellow' size='large' /> :
    <Icon name='check circle' color='green' size='large' />
  }
  content={<>
    <div>Transferencia: {vehicle.hasAccessories ? vehicle.transfer : 'N/A'}</div>
    <div>Reserva Disp: {vehicle.hunter === 'SI' ?
      (vehicle.deviceReserved === 'S' ? 'SI' : 'NO') : 'N/A'}</div>
    {vehicle.hasAccessories && vehicle.transferStatus !== 'C' && <div>Transferencia sin confirmar en JDE</div>}
  </>
  } />;
};

export const getColumns = ({
  renderAccesoriesCombo,
  checkReservation,
}) => {
  return [
    {
      'id': 'accessoriosCheck',
      'Header': 'ACC.',
      'width': 40,
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            {row.original.accessoriesValidated ?
              renderCheckIcon() :
              renderCrossIcon()
            }
          </div>
        );
      },
      'Filter': () => {
        return null;
      },
    },
    {
      'id': 'hunterCheck',
      'Header': 'DISP.',
      'width': 40,
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center'}}>
            {row.original.hunterValidated ?
              renderCheckIcon() :
              renderCrossIcon()
            }
          </div>
        );
      },
      'Filter': () => {
        return null;
      },
    },
    {
      'id': 'reserveCheck',
      'Header': 'RESERVA',
      'width': 40,
      'Cell': ({row}) => {
        return (
          <div style={{'textAlign': 'center', 'cursor': 'pointer'}}>
            {checkReservation(row.original) ?
              renderReservedCheckIcon(row.original) :
              renderCrossIcon()
            }
          </div>
        );
      },
      'Filter': () => {
        return null;
      },
    },
    {
      'Header': 'FACTURAR A',
      'accessor': 'invoiceTo',
      'width': 250,
    },
    {
      'Header': 'ASIGNADO A',
      'accessor': 'assignedTo',
      'width': 250,
    },
    {
      'Header': 'PEDIDO',
      'accessor': 'orderNo',
      'width': 150,
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
      'width': 300,
    },
    {
      'Header': 'SFX',
      'accessor': 'sfx',
      'width': 50,
    },
    {
      'Header': 'KATASHIKI',
      'accessor': 'katashiki',
      'width': 150,
    },
    {
      'Header': 'CHASIS',
      'accessor': 'chassis',
      'width': 200,
    },
    {
      'Header': 'ACCESORIOS',
      'accessor': 'combo',
      'Cell': ({row}) => {
        return (renderAccesoriesCombo(row.original.combo, row.original.comboDetail));
      },
      'width': 150,
    },
    {
      'Header': 'HUNTER',
      'accessor': 'hunter',
      'Cell': ({row}) => {
        return (<div style={{'textAlign': 'center'}}>{row.original.hunter}</div>);
      },
    },
    {
      'Header': 'UBICACIÓN',
      'accessor': 'location',
      'width': 150,
    },
  ];
};
